var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "el-col",
        { attrs: { span: _vm.colSpan } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("billingPage.CustomerName"),
                prop: "cusId",
              },
            },
            [
              _c("BjSelectLov", {
                attrs: {
                  "option-list": _vm.customerList,
                  disabled: _vm.isEdit,
                  placeholder: _vm.$t("customerNameText"),
                },
                model: {
                  value: _vm.form.cusId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "cusId", $$v)
                  },
                  expression: "form.cusId",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.colSpan } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("billingPage.PalletQty"),
                prop: "palletQty",
              },
            },
            [
              _c("BjInputNumber", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.palletQty,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "palletQty", $$v)
                  },
                  expression: "form.palletQty",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: _vm.colSpan * 2 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("billingPage.startDate"),
                prop: "startTime",
              },
            },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "datetime",
                  format: "dd/MM/yyyy HH:mm",
                  placeholder: _vm.$t("billingPage.startDate"),
                  "picker-options": _vm.pickerOptions,
                },
                model: {
                  value: _vm.form.startTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "startTime", $$v)
                  },
                  expression: "form.startTime",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }